/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TStripeConnectAccountResponse } from '../models/TStripeConnectAccountResponse';
import type { TStripeConnectOnboardingResponse } from '../models/TStripeConnectOnboardingResponse';
import type { TStripeConnectStatusResponse } from '../models/TStripeConnectStatusResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StripeConnectService {
    /**
     * Create a Stripe Connect Express account for the authenticated TM
     * @returns TStripeConnectAccountResponse Ok
     * @throws ApiError
     */
    public static createConnectAccount(): CancelablePromise<TStripeConnectAccountResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe-connect/account',
        });
    }
    /**
     * Get an onboarding link for the authenticated TM's Connect account
     * @param requestBody
     * @returns TStripeConnectOnboardingResponse Ok
     * @throws ApiError
     */
    public static getOnboardingLink(
        requestBody: {
            return_url: string;
        },
    ): CancelablePromise<TStripeConnectOnboardingResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/stripe-connect/onboarding-link',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Connect account status for the authenticated TM
     * @returns TStripeConnectStatusResponse Ok
     * @throws ApiError
     */
    public static getConnectStatus(): CancelablePromise<TStripeConnectStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stripe-connect/status',
        });
    }
}
